import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

const loadState = (): { organizationId: string; organizationName?: string; } => {
    const savedState = localStorage.getItem('selectedOrganization');
    return savedState ? JSON.parse(savedState) as { organizationId: string; organizationName?: string; } : { organizationId: '' };
};

const initialState: { organizationId: string; organizationName?: string; defaultTaxPercent?: number; } = loadState();

const selectedOrganizationSlice = createSlice({
    name: 'selectedOrganization',
    initialState,
    reducers: {
        setSelectedOrganization: (state, action: PayloadAction<{ organizationId: string; organizationName?: string; defaultTaxPercent?: number; }>) => {
            localStorage.setItem('selectedOrganization', JSON.stringify(action.payload));
            return action.payload;
        },
        removeSelectedOrganization: (state) => {
            localStorage.removeItem('selectedOrganization');
            return { organizationId: '' };
        },
    },
});

export const { setSelectedOrganization, removeSelectedOrganization } = selectedOrganizationSlice.actions;
export default selectedOrganizationSlice.reducer;
export const selectSelectedOrganization = (state: RootState) => state.selectedOrganization;